import React, { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { ActivityPayerRulesAxiosInstance } from "../../Network/ActivityPayerRulesAxiosInstance";
import { activityPayerRules, Result } from "../../interface/activityPayerRules";
import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "shared/DataTable";
import { Button } from "../../components/ui/button";
import Joi from "joi";
import { Option } from "../../interface/Option";
import NetworkNames from "../Shared/NetworkNames";
import PolicyNames from "../Shared/PolicyNames"
const ActivityPayerRules: React.FC = () => {
  const [items, setItems] = useState<activityPayerRules>({ result: [] });
  const [providerIds, setproviderIds] = useState<string[]>([]);
  const [IdproviderError, setIdProviderError] = useState<string>("");
  const [relationId, setrelationId] = useState<number[]>([]);
  const [IdrelationError, setIdRelationError] = useState<string>("");
  const [applyToOtherProviders, setapplyToOtherProviders] =
    useState<boolean>(true);
  const [applyToOtherNetworks, setapplyToOtherNetworks] =
    useState<boolean>(true);
  const [applyToOtherPolicies, setapplyToOtherPolicies] =
    useState<boolean>(true);
  const [applyToOtherPatients, setapplyToOtherPatients] =
    useState<boolean>(true);
  const [active, setactive] = useState<boolean>(true);

  const [networks, setnetworks] = useState<string[]>([]);
  const [policies, setpolicies] = useState<string[]>([]);
  const [patients, setpatients] = useState<string[]>([]);
  const token = localStorage.getItem('token') || "";
  const [selectedNetworks, setSelectedNetworks] = useState<Option[]>([]);
  const [selectedPolicy, setSelectedPolicy] = useState<Option[]>([]);   

  const [editIndex, setEditIndex] = useState<null | number>(null);

  const idrelationschema = Joi.string().allow("") // Allow empty string
  .regex(/^[0-9,]*$/).messages({
    "string.pattern.base": "please enter only number",
  });  
  const idproviderschema = Joi.string().allow("") // Allow empty string
  .regex(/^[0-9,]*$/).messages({
    "string.pattern.base": "please enter only number",
  });
  // ............................................. get data ...............................................
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Result[] }> =
        await ActivityPayerRulesAxiosInstance.get("GetALLActivityPayerRules");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  //............................................. end get data ...............................................
  //............................................. add data ...............................................

  const handlIdrelationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = idrelationschema.validate(value);
  
    if (error) {
      setIdRelationError(error.message); 
    } else {
      setIdRelationError(""); 
      const inputValue = e.target.value.trim();
      setrelationId(e.target.value.split(",").map(Number))
     }
  };

  const handlIdproviderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
  // check the entry using Joi
    const { error } = idproviderschema.validate(value);
  
    if (error) {
      setIdProviderError(error.message); 
    } else {
      setIdProviderError(""); 
      const inputValue = e.target.value.trim();
      setproviderIds([e.target.value])
     }
  };

  const addItem = async (): Promise<void> => {
    const Networks=selectedNetworks.map(option => option.label);
    const Policy=selectedPolicy.map(option => option.label);
    try {
      const newActivityPayerRules = {
        relation_id: relationId,
        provider_ids: providerIds,
        apply_to_other_providers: applyToOtherProviders,
        networks: Networks,
        apply_to_other_networks: applyToOtherNetworks,
        policies: Policy,
        apply_to_other_policies: applyToOtherPolicies,
        patients: patients,
        apply_to_other_patients: applyToOtherPatients,
        active: active,
        token: token,
      };
      await ActivityPayerRulesAxiosInstance.post(
        "AddActivityPayerRules",
        newActivityPayerRules
         
      );
      fetchItems();
      setproviderIds([]);
      setrelationId([]);
      setapplyToOtherProviders(true);
      setapplyToOtherNetworks(true);
      setapplyToOtherPolicies(true);
      setpatients([]);
      setapplyToOtherPatients(true);
      setactive(true);
      setSelectedNetworks([]);
      setSelectedPolicy([]);

      console.log("New group Added Successfully:", newActivityPayerRules);

      console.log(items);
    } catch (error) {
      console.error("Error adding item:", error);
    }
  };

  //.............................................end add data ...............................................
  //............................................. remove data ...............................................

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await ActivityPayerRulesAxiosInstance.delete(
        `deleteActivityPayerRules/${id}`, {
        
           data: { token: token }, 
         }
      );
      console.log(id);
      fetchItems();
    } catch (error) {
      console.error("Error removing item:", error);
    }
  };
  //.............................................end remove data ...............................................
  // ..................................................update data...............................
  const updateItem = async (id: string | number): Promise<void> => {
    const Networks=selectedNetworks.map(option => option.label);
    const Policy=selectedPolicy.map(option => option.label);
    try {
      const updatedItem = {
        relation_id: relationId,
        provider_ids: providerIds,
        apply_to_other_providers: applyToOtherProviders,
        networks: Networks,
        apply_to_other_networks: applyToOtherNetworks,
        policies: Policy,
        apply_to_other_policies: applyToOtherPolicies,
        patients: patients,
        apply_to_other_patients: applyToOtherPatients,
        active: active,
        id: id,
        token: token,
      };

      await ActivityPayerRulesAxiosInstance.put(
        `updateActivityPayerRules`,updatedItem
      );
      fetchItems();

      setproviderIds([]);
      setrelationId([]);
      setapplyToOtherProviders(true);
      setapplyToOtherNetworks(true);
      setapplyToOtherPolicies(true);
      setpatients([]);
      setapplyToOtherPatients(true);
      setactive(true);
      setSelectedNetworks([]);
      setSelectedPolicy([]);
      setEditIndex(null);

      console.log("New group updated successfully:", updatedItem);
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };


  const resetForm = () => {
    setproviderIds([]);
    setrelationId([]);
    setapplyToOtherProviders(true);
    setnetworks([]);
    setapplyToOtherNetworks(true);
    setpolicies([]);
    setapplyToOtherPolicies(true);
    setpatients([]);
    setapplyToOtherPatients(true);
    setactive(true);
    setSelectedNetworks([]);
    setSelectedPolicy([]);
    setEditIndex(null);

  };

  //.............................................end update data ...............................................

  const handleNetworksChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedNetworks(selectedOptions);
  };
  const handlePolicyChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setSelectedPolicy(selectedOptions);
  };

  const handleEdit =  (item: Result) => {
    setrelationId(item.relation_id);
    setproviderIds(item.provider_ids);
    setapplyToOtherProviders(item.apply_to_other_providers);
   const Networks = (item.networks || []).map((networks: string) => ({
    label: networks,
    value: networks,
  }));
  setSelectedNetworks(Networks);
  const Policy = (item.policies || []).map((policies: string) => ({
    label: policies,
    value: policies,
  }));
  setSelectedPolicy(Policy);
   
    setapplyToOtherNetworks(item.apply_to_other_networks);
    setapplyToOtherPolicies(item.apply_to_other_policies);
    setpatients(item.patients);
    setapplyToOtherPatients(item.apply_to_other_patients);
    setactive(item.active);
    setEditIndex(item.id);
  }
  
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },
    {
      accessorKey: "relation_id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
RelationID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const codes = row.getValue("relation_id") as string[];
        return Array.isArray(codes) ? codes.join(", ") : codes;
      },
    },
    {
      accessorKey: "provider_ids",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
ProviderIDs
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const codes = row.getValue("provider_ids") as string[];
        return Array.isArray(codes) ? codes.join(", ") : codes;
      },
    },
    {
      accessorKey: "apply_to_other_providers",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ApplyToOtherProviders
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
    {
      accessorKey: "networks",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Networks
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Networks = row.getValue("networks") as string[];
        return Array.isArray(Networks) ? Networks.join(", ") : Networks;
      },
    },
    {
      accessorKey: "policies",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Policies
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Policies = row.getValue("policies") as string[];
        return Array.isArray(Policies) ? Policies.join(", ") : Policies;
      },
    },
    {
      accessorKey: "patients",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
Patients
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const Patients = row.getValue("patients") as string[];
        return Array.isArray(Patients) ? Patients.join(", ") : Patients;
      },
    },
    {
      accessorKey: "active",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 Active
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
  
    {
      accessorKey: "apply_to_other_networks",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
 ApplyToOtherNetworks
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
      {
      accessorKey: "apply_to_other_policies",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ApplyToOtherPolicies
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
    {
      accessorKey: "apply_to_other_patients",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
        ApplyToOtherPatients
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
            ? " ↓"
            : ""}
        </Button>
      ),
    },  
  ];



  useEffect(() => {
    fetchItems();
  }, []);

  return (
    <div className=" container" style={{ margin: "30px" }}>
      {/* title */}
      <h5>
        Activity Payer Rules Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>
  
      {/* model */}
      {/* tabIndex="-1" */}
      <div
  className="modal fade"
  id="exampleModal"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content" style={{ width: "135%" }}>
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">
          Add Item
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div className="container">
        <div className="row">
          {/* First Column */}
          <div className="col-md-6">
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Relation ID:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={relationId.join(",")}
                onChange={handlIdrelationChange }
              />
           { IdrelationError&& <div style={{ color: "red" }}>{IdrelationError}</div>}

            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Provider ID:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={providerIds.join(",")}
                onChange={handlIdproviderChange}
              />
        { IdproviderError&& <div style={{ color: "red" }}>{IdproviderError}</div>}

            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Networks:</label>
           {/*   <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={networks.join(",")}
                onChange={(e) => setnetworks([e.target.value])}
              />*/}
            <div style={{ width: "130%"}}>
            <NetworkNames onChange={handleNetworksChange} />
            </div> 
            </div>
            <div style={{ marginBottom: "10px" }}>
              <label className="m-2">Policies:</label>
            {/*  <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={policies.join(",")}
                onChange={(e) => setpolicies([e.target.value])}
              />*/}
               <div style={{ width: "130%"}}>
               <PolicyNames onChange={handlePolicyChange} />
            </div> 
            </div>
            <div style={{ marginBottom: "45px" }}>
              <label className="m-2"> Patients:</label>
              <input
                type="text"
                className="form-control"
                style={{ marginBottom: "10px" }}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                value={patients.join(",")}
                onChange={(e) => setpatients([e.target.value])}
              />
            </div>
          </div>


          {/* Second Column */}
          <div className="col-md-6">
          <div style={{ marginBottom: "45px", marginTop:"35px" }}>
          <span>
                  <label className="m-2"> Active :</label>

                  <span style={{ marginRight: "10px" }}>
                    {" "}
                    True:{" "}
                    <input
                      type="radio"
                      name="active"
                      value="true"
                      checked={active === true}
                      onChange={(e) => setactive(e.target.value === "true")}
                    />{" "}
                  </span>
                  <span>
                    {" "}
                    False:{" "}
                    <input
                      type="radio"
                      name="active"
                      value="false"
                      checked={active === false}
                      onChange={(e) => setactive(e.target.value === "true")}
                    />{" "}
                  </span>
                </span>
                </div>
            <div style={{ marginBottom: "50px" }}>
            <span>
              <label className="m-2"> Apply To Other Providers:</label>
              <span style={{ marginRight: "10px" }}>
                {" "}
                True:{" "}
                <input
                  type="radio"
                  name="Providers"
                  value="true"
                  checked={applyToOtherProviders === true}
                  onChange={(e) =>
                    setapplyToOtherProviders(e.target.value === "true")
                  }
                />{" "}
              </span>
              <span>
                {" "}
                False:{" "}
                <input
                  type="radio"
                  name="Providers"
                  value="false"
                  checked={applyToOtherProviders === false}
                  onChange={(e) =>
                    setapplyToOtherProviders(e.target.value === "true")
                  }
                />{" "}
              </span>
            </span>
</div>
<div style={{ marginBottom: "45px" }}>
            <span>
              <label className="m-2"> Apply To Other Networks:</label>
              <span style={{ marginRight: "10px" }}>
                {" "}
                True:{" "}
                <input
                  type="radio"
                  name="Networks"
                  value="true"
                  checked={applyToOtherNetworks === true}
                  onChange={(e) =>
                    setapplyToOtherNetworks(e.target.value === "true")
                  }
                />{" "}
              </span>
              <span>
                {" "}
                False:{" "}
                <input
                  type="radio"
                  name="Networks"
                  value="false"
                  checked={applyToOtherNetworks === false}
                  onChange={(e) =>
                    setapplyToOtherNetworks(e.target.value === "true")
                  }
                />{" "}
              </span>
            </span>
     </div>
     <div style={{ marginBottom: "50px" }}>
            <span>
              
              <label className="m-2"> Apply To Other Policies:</label>
              <span style={{ marginRight: "10px" }}>
                {" "}
                True:{" "}
                <input
                  type="radio"
                  name="Policies"
                  value="true"
                  checked={applyToOtherPolicies === true}
                  onChange={(e) =>
                    setapplyToOtherPolicies(e.target.value === "true")
                  }
                />{" "}
              </span>
              <span>
                {" "}
                False:{" "}
                <input
                  type="radio"
                  name="Policies"
                  value="false"
                  checked={applyToOtherPolicies === false}
                  onChange={(e) =>
                    setapplyToOtherPolicies(e.target.value === "true")
                  }
                />{" "}
              </span>
            </span>
            </div>
            <span>
                  <label className="m-2"> Apply To Other Patients :</label>

                  <span style={{ marginRight: "10px" }}>
                    {" "}
                    True:{" "}
                    <input
                      type="radio"
                      name="Patients"
                      value="true"
                      checked={applyToOtherPatients === true}
                      onChange={(e) =>
                        setapplyToOtherPatients(e.target.value === "true")
                      }
                    />{" "}
                  </span>
                  <span>
                    {" "}
                    False:{" "}
                    <input
                      type="radio"
                      name="Patients"
                      value="false"
                      checked={applyToOtherPatients === false}
                      onChange={(e) =>
                        setapplyToOtherPatients(e.target.value === "true")
                      }
                    />{" "}
                  </span>
                </span>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-primary"
          onClick={editIndex === null ? addItem : () => updateItem(editIndex)}
        >
          {editIndex === null ? "Add Item" : "Update Item"}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={resetForm}
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>


      {/* table */}
      <DataTable
  columns={columns}
  data={items.result}
  searchColumn="relation_id"
  addButtonLabel="Add New ActivityPayerRules" // Custom button text
  modalId="exampleModal" // Custom add modal ID
  showAddButton={true} // Control visibility
  onEdit={handleEdit}
  onDelete={removeItem}
/>
    </div>
  );
};
export default ActivityPayerRules;
